import { useState } from 'react'
import { GetDataError } from 'restful-react'
import Logout from '../Logout'
import { env } from '../../services/EnvironmentVariables'
import { Button } from '@/UIComponents2/Button'
import ElectronIPC from '@/services/ElectronIPC'

function LoginError({ error }: { error: GetDataError<any> | { status: number; data: any } }) {
    const [showLogout, set_showLogout] = useState(false)
    const status = error.status

    if (error?.data?.code === 'recalled') {
        return (
            <Container>
                <div className="text-xl font-semibold pb-6">This version of Muse has been deprecated</div>
                <div className="text-sm pb-2">
                    This version of Muse (v{env.APP_VERSION}) is too old and cannot be used anymore. We no longer
                    maintain this version of Muse.
                </div>
                <div className="text-sm pb-2">
                    Please install the latest version by visiting our website at{' '}
                    <Button
                        variant="link"
                        onClick={() => ElectronIPC.openLinkInBrowser('http://musesessions.co/download')}
                    >
                        musesessions.co/download
                    </Button>
                </div>
                {showLogout && <Logout />}
            </Container>
        )
    } else if (status == 503) {
        return (
            <Container>
                <div className="text-xl font-semibold pb-6">Error: Service Unavailable</div>
                <div className="text-sm pb-2">We are currently undergoing maintenance. Please try again later.</div>
                <Button variant="link" onClick={() => set_showLogout(true)}>
                    Log out
                </Button>
                {showLogout && <Logout />}
            </Container>
        )
    } else {
        return (
            <Container>
                <div className="text-xl font-semibold pb-6">Login Error: {error.status}</div>
                <div className="text-sm pb-2">There seems to have been an error while trying to log you in.</div>
                <pre className="text-sm mb-5 whitespace-pre-wrap">{JSON.stringify(error.data)}</pre>
                <Button variant="link" onClick={() => set_showLogout(true)}>
                    Log out
                </Button>
                {showLogout && <Logout />}
            </Container>
        )
    }
}

function Container({ children }: any) {
    return (
        <div className="flex flex-col h-full items-center justify-center">
            <div className="px-8 md:max-w-[600px]">{children}</div>
        </div>
    )
}

export default LoginError
